import Stack from '@mui/material/Stack';
import { ReactNode, useContext } from 'react';
import { TimelineContext } from '@/common/components/timeline/TimelineContext.ts';

export interface TimelineIconProps {
  color: { 50: string; 700: string };
  children?: ReactNode;
}

export const TimelineIcon = ({ color, children }: TimelineIconProps) => {
  const { backgroundColor } = useContext(TimelineContext);

  return (
    <Stack
      width={56}
      height={56}
      sx={{ backgroundColor }}
      justifyContent="center"
      alignItems="center"
      borderRadius="50%"
    >
      <Stack
        width={48}
        height={48}
        borderRadius="50%"
        sx={{ backgroundColor: color[50], color: color[700] }}
        justifyContent="center"
        alignItems="center"
      >
        {children}
      </Stack>
    </Stack>
  );
};
